import React, { FunctionComponent, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Helmet } from 'react-helmet';
import { useGetBackofficeLandingQuery } from 'services/exploreApi';
import { LandingComponent } from 'app/types';
import Loader from 'common/components/Loader/Loader';
import ComponentPreview from './ComponentPreview';
import styles from './LandingForm.module.scss';

const LandingPreview: FunctionComponent = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data: landing, isLoading } = useGetBackofficeLandingQuery(id || '');

  useEffect(() => {
    if (landing === null) {
      navigate('/');
    }
  }, [landing]);
  if (isLoading) return <Loader />;
  return (
    <div className={`${styles.uaCms}`} style={{ display: 'flex', flexDirection: 'column' }}>
      <Helmet>
        <title>{landing?.data.meta_title}</title>
        <meta name="description" content={landing?.data.meta_description} />
      </Helmet>
      {landing?.data.landing_components &&
        landing?.data.landing_components.map((landing_cmp: LandingComponent) => {
          return <ComponentPreview key={landing_cmp.id} landing_cmp={landing_cmp} />;
        })}
    </div>
  );
};

export default LandingPreview;
